import AuthModule from '../auth/AuthModule'

export default {
  install (Vue) {
    Vue.prototype.$auth = new AuthModule()
  }
}
